<template>
  <div :class="bem.m('body')">
    <div :class="bem.m('body-container')">
      <json-xml
        v-if="bodyKey === 'json'"
        v-model:value="jsonSchema"
        :type="bodyKey"
      />
      <json-xml
        v-if="bodyKey === 'xml'"
        v-model:value="jsonSchema"
        :type="bodyKey"
      />
      <ll-code-editor v-if="bodyKey === 'raw'" v-model:value="description" />
      <params-table
        v-if="bodyKey === 'x-www-form-urlencoded'"
        :columns="paramsTableColumns"
        :data-source="parameters"
      />
      <params-table
        v-if="bodyKey === 'form-data'"
        :columns="formdataTableColumns"
        :data-source="parameters"
      />
      <div v-if="bodyKey === 'none'" :class="bem.e('none')">
        <!-- <ll-empty>
          <template #title> 该请求没有 Body 体 </template>
        </ll-empty> -->
        该请求没有 Body 体
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { inject, ref, watch } from 'vue'

import JsonXml from './json-xml.vue'

import paramsTable from './params-table.vue'

import type { BodyParams } from '../config'

import {
  bodyEmits,
  bodyProps,
  formdataTableColumns,
  paramsTableColumns,
} from '../config'

defineOptions({ name: 'BodyComponent' })

const props = defineProps(bodyProps)

const emits = defineEmits(bodyEmits)

const bem = createNamespace('api-component')

const disabled = inject('disabled')

const bodyKey = ref<BodyParams['type']>(props.value.bodyParams.type)

const parameters = ref<BodyParams['parameters']>(
  props.value.bodyParams.parameters
)

const jsonSchema = ref<BodyParams['jsonSchema']>(
  props.value.bodyParams.jsonSchema
)

const description = ref<BodyParams['description']>(
  props.value.bodyParams.description
)

const handleChange = (e) => {
  if (e === 'none') {
    parameters.value = []
  }
}

watch([parameters, jsonSchema, description], () => {
  const obj = {
    ...props.value,
    bodyParams: {
      type: bodyKey.value,
      parameters: parameters.value,
      jsonSchema: jsonSchema.value,
      description: description.value,
    },
  }
  emits('change', obj)
  emits('update:value', obj)
})
</script>
